var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import validator from 'validator';
export var ValidationResultType;
(function (ValidationResultType) {
    ValidationResultType[ValidationResultType["ERROR"] = 0] = "ERROR";
    ValidationResultType[ValidationResultType["VALID"] = 1] = "VALID";
})(ValidationResultType || (ValidationResultType = {}));
export var ValidationValueType;
(function (ValidationValueType) {
    ValidationValueType[ValidationValueType["VALUE"] = 0] = "VALUE";
    ValidationValueType[ValidationValueType["TRANSLATION"] = 1] = "TRANSLATION";
})(ValidationValueType || (ValidationValueType = {}));
var ValidationResultBuilder = /** @class */ (function () {
    function ValidationResultBuilder() {
        this.results = [];
    }
    ValidationResultBuilder.prototype.invalid = function (key, values) {
        if (values === void 0) { values = []; }
        this.results.push({ type: ValidationResultType.ERROR, message: { key: key, values: values } });
        return this;
    };
    ValidationResultBuilder.prototype.valid = function (key) {
        this.results.push({ type: ValidationResultType.VALID });
        return this;
    };
    ValidationResultBuilder.prototype.build = function () {
        var results = this.results;
        this.results = [];
        return results;
    };
    return ValidationResultBuilder;
}());
var Validator = /** @class */ (function () {
    function Validator() {
        this.result = new ValidationResultBuilder();
    }
    Validator.prototype.execute = function (field, value, form) {
        this.validate(field, value, form);
        return this.result.build();
    };
    /*
     * Helper function to create a validation value
     */
    Validator.prototype.v = function (value) {
        return { type: ValidationValueType.VALUE, value: value };
    };
    /*
     * Helper function to create a translation validation value
     */
    Validator.prototype.t = function (value) {
        return { type: ValidationValueType.TRANSLATION, value: value };
    };
    return Validator;
}());
export { Validator };
var SizeValidator = /** @class */ (function (_super) {
    __extends(SizeValidator, _super);
    function SizeValidator(min, max) {
        var _this = _super.call(this) || this;
        _this.min = min;
        _this.max = max;
        return _this;
    }
    SizeValidator.prototype.validate = function (key, value) {
        if (value.length < this.min)
            this.result.invalid('validation.size.min', [this.t(String(key)), this.v(this.min)]);
        if (value.length > this.max)
            this.result.invalid('validation.size.max', [this.t(String(key)), this.v(this.max)]);
    };
    return SizeValidator;
}(Validator));
export { SizeValidator };
var EmailValidator = /** @class */ (function (_super) {
    __extends(EmailValidator, _super);
    function EmailValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailValidator.prototype.validate = function (field, value) {
        if (!validator.isEmail(value))
            this.result.invalid('validation.email', [this.t(String(field))]);
    };
    return EmailValidator;
}(Validator));
export { EmailValidator };
var ConfirmValidator = /** @class */ (function (_super) {
    __extends(ConfirmValidator, _super);
    function ConfirmValidator(field) {
        var _this = _super.call(this) || this;
        _this.field = field;
        return _this;
    }
    ConfirmValidator.prototype.validate = function (field, value, form) {
        if (value !== form[this.field]) {
            this.result.invalid('validation.confirm', [
                this.t(String(this.field))
            ]);
        }
    };
    return ConfirmValidator;
}(Validator));
export { ConfirmValidator };
var MinSizeValidator = /** @class */ (function (_super) {
    __extends(MinSizeValidator, _super);
    function MinSizeValidator(min) {
        var _this = _super.call(this) || this;
        _this.min = min;
        return _this;
    }
    MinSizeValidator.prototype.validate = function (field, value) {
        if (value.length < this.min) {
            this.result.invalid('validation.size.min', [
                this.t(String(field)),
                this.v(this.min)
            ]);
        }
    };
    return MinSizeValidator;
}(Validator));
export { MinSizeValidator };
var MaxSizeValidator = /** @class */ (function (_super) {
    __extends(MaxSizeValidator, _super);
    function MaxSizeValidator(max) {
        var _this = _super.call(this) || this;
        _this.max = max;
        return _this;
    }
    MaxSizeValidator.prototype.validate = function (field, value) {
        if (value.length > this.max) {
            this.result.invalid('validation.size.max', [
                this.t(String(field)),
                this.v(this.max)
            ]);
        }
    };
    return MaxSizeValidator;
}(Validator));
export { MaxSizeValidator };
var NumberValidator = /** @class */ (function (_super) {
    __extends(NumberValidator, _super);
    function NumberValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumberValidator.prototype.validate = function (field, value) {
        if (isNaN(parseInt(value)))
            this.result.invalid('validation.number', [this.t(String(field))]);
    };
    return NumberValidator;
}(Validator));
export { NumberValidator };
var URLValidator = /** @class */ (function (_super) {
    __extends(URLValidator, _super);
    function URLValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    URLValidator.prototype.validate = function (field, value) {
        if (!validator.isURL(value))
            this.result.invalid('validation.url', [this.t(String(field))]);
    };
    return URLValidator;
}(Validator));
export { URLValidator };
var PasswordValidator = /** @class */ (function (_super) {
    __extends(PasswordValidator, _super);
    function PasswordValidator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requirements = {
            minLength: 10,
            minNumbers: 1,
            minUppercase: 1,
            minLowercase: 1,
            minSymbols: 0,
        };
        _this.maxLength = 100;
        return _this;
    }
    PasswordValidator.prototype.validate = function (field, value) {
        if (!PasswordValidator.validatePassword(value, { minLength: this.requirements.minLength })) {
            this.result.invalid('validation.password.min', [
                this.v(this.requirements.minLength)
            ]);
        }
        if (!PasswordValidator.validatePassword(value, { minNumbers: this.requirements.minNumbers })) {
            this.result.invalid('validation.password.numbers', [
                this.v(this.requirements.minNumbers)
            ]);
        }
        if (!PasswordValidator.validatePassword(value, { minUppercase: this.requirements.minUppercase })) {
            this.result.invalid('validation.password.uppercase', [
                this.v(this.requirements.minUppercase)
            ]);
        }
        if (!PasswordValidator.validatePassword(value, { minLowercase: this.requirements.minLowercase })) {
            this.result.invalid('validation.password.lowercase', [
                this.v(this.requirements.minLowercase)
            ]);
        }
        if (value.length > this.maxLength) {
            this.result.invalid('validation.password.max', [
                this.v(this.maxLength)
            ]);
        }
    };
    PasswordValidator.validatePassword = function (value, requirements) {
        var options = {
            minLength: 0,
            minNumbers: 0,
            minUppercase: 0,
            minLowercase: 0,
            minSymbols: 0,
        };
        return validator.isStrongPassword(value, __assign(__assign({}, options), requirements));
    };
    return PasswordValidator;
}(Validator));
export { PasswordValidator };
var PhoneNumberValidator = /** @class */ (function (_super) {
    __extends(PhoneNumberValidator, _super);
    function PhoneNumberValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PhoneNumberValidator.prototype.validate = function (field, value) {
        if (!validator.isMobilePhone(value)) {
            this.result.invalid('validation.phone', [this.t(String(field))]);
        }
    };
    return PhoneNumberValidator;
}(Validator));
export { PhoneNumberValidator };
